import Button from '@components/button/Button';
import Icon from '@components/icon/Icon';
import { ButtonSize, ButtonVariant } from '@types';

import Modal from './Modal';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message?: string;
  iconName?: string;
  ModalIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  cancelButtonStyle?: string;
  confirmButtonStyle?: string;
  handleConfirm: () => void;
  handleCancel: () => void;
  className?: string;
  isConfirmButtonLoading?: boolean;
  children?: any;
  wrapperClass?: string;
  isConfirmButtonDisabled?: boolean;
  buttonIds?: { confirmButton?: string; cancelButton?: string };
  confirmButtonLabelStyle?: string;
  primaryButtonVariant?: ButtonVariant;
  primaryButtonSize?: ButtonSize;
  secondaryButtonVariant?: ButtonVariant;
  secondaryButtonSize?: ButtonSize;
}

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  iconName,
  ModalIcon,
  cancelButtonLabel = 'Cancel',
  confirmButtonLabel = 'Confirm',
  cancelButtonStyle = '',
  confirmButtonStyle = 'text-primary',
  handleConfirm,
  handleCancel,
  className,
  isConfirmButtonLoading,
  children,
  wrapperClass,
  isConfirmButtonDisabled,
  buttonIds,
  confirmButtonLabelStyle,
  primaryButtonVariant = 'transparent',
  primaryButtonSize = 'none',
  secondaryButtonVariant = 'transparent',
  secondaryButtonSize = 'none'
}: ConfirmationModalProps) => (
  <Modal
    isOpen={isOpen}
    onCancel={handleCancel}
    className={`!rounded-xl ${wrapperClass}`}
  >
    <div className={`p-6 pb-0 ${className && className}`}>
      {iconName && (
        <div className="mb-4 flex items-center justify-center">
          <Icon name={iconName} size="extralarge" />
        </div>
      )}
      {ModalIcon && (
        <div className="mb-4 flex items-center justify-center">
          <ModalIcon className="size-8" />
        </div>
      )}
      <div className="mb-3 flex justify-center whitespace-pre-wrap break-normal text-center text-lg font-medium text-content">
        {title}
      </div>
      {message && (
        <div className="flex justify-center whitespace-pre-wrap break-words text-center text-base font-normal text-grey">
          {message}
        </div>
      )}
      {children && children}
      <div className="mt-3 flex gap-3">
        <Button
          data-testid={buttonIds?.cancelButton}
          handleClick={handleCancel}
          variant={secondaryButtonVariant || 'transparent'}
          size={secondaryButtonSize || 'none'}
          className={`${
            secondaryButtonVariant === 'transparent'
              ? 'w-1/2 py-6 pt-3 text-base font-medium'
              : 'w-1/2'
          } ${cancelButtonStyle || ''}`}
          label={cancelButtonLabel}
        />
        <Button
          data-testid={buttonIds?.confirmButton}
          handleClick={handleConfirm}
          variant={primaryButtonVariant || 'transparent'}
          size={primaryButtonSize || 'none'}
          className={`${
            primaryButtonVariant === 'transparent'
              ? 'w-1/2 py-6 pt-3 text-base font-medium'
              : 'w-1/2'
          } ${confirmButtonStyle || ''}`}
          loading={isConfirmButtonLoading || false}
          label={confirmButtonLabel}
          labelStyle={confirmButtonLabelStyle}
          disabled={isConfirmButtonDisabled}
        />
      </div>
    </div>
  </Modal>
);

export default ConfirmationModal;
